import React from 'react';
import { BrowserRouter as Router, Redirect, Route, Switch, useLocation } from 'react-router-dom';

import ProtectedRoute from './ProtectedRoute';
import { ROUTES } from '../constants/route';
import { UserRoles } from '../constants/role';
import MerchantPaymentsPage from '../pages/Merchant/MerchantPayments';
import MerchantCreateProfilePage from '../pages/Merchant/MerchantCreateProfilePage';
import ScanPage from '../components/Scan/ScanPage';
import MerchantLandingPage from '../pages/Merchant/MerchantLandingPage';
import AuthCallbackPage from '../pages/AuthCallbackPage/AuthCallbackPage';
import MerchantPassportSelection from '../pages/Merchant/MerchantPassportSelection';
import MerchantScanPage from '../pages/Merchant/MerchantScanPage';
import MerchantLoginPage from '../pages/Merchant/MerchantLoginPage';
import MerchantSignupPage from '../pages/Merchant/MerchantSignupPage';
import MerchantSetPasswordPage from '../pages/Merchant/MerchantSetPasswordPage';
import MerchantResetPasswordPage from '../pages/Merchant/MerchantResetPasswordPage';
import MerchantRecoverPasswordPage from '../pages/Merchant/MerchantRecoverPasswordPage';
import MerchantPerksListingPage from '../pages/Merchant/MerchantPerksListingPage';
import MerchantOfferCreateOrEditPage from '../pages/Merchant/MerchantOfferCreateOrEditPage';
import NotFoundPage from '../pages/NotFoundPage/NotFoundPage';
import { MerchantCustomerSignupPage } from '../pages/Merchant/MerchantCustomerSignupPage';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ScrollToTop: React.FC<any> = ({ children }) => {
  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname]);

  return children;
};

const Routes: React.FC = () => (
  <Router>
    <ScrollToTop>
      <Switch>
        <Route exact path={ROUTES.LANDING} component={MerchantLandingPage} />
        <Route exact path={ROUTES.AUTH_CALLBACK} component={AuthCallbackPage} />
        
        <ProtectedRoute
          exact
          path={ROUTES.MERCHANT_DATA_PASS}
          Component={MerchantPassportSelection}
          accessRole={UserRoles.MERCHANT}
        />

        <ProtectedRoute
          exact
          path={ROUTES.MERCHANT_DATA_PASS_TERMINAL}
          Component={MerchantLandingPage}
          accessRole={UserRoles.MERCHANT}
        />
        <ProtectedRoute
          exact
          path={ROUTES.MERCHANT_SCANNER}
          Component={MerchantScanPage}
          accessRole={UserRoles.MERCHANT}
        />
        <ProtectedRoute
          exact
          path={ROUTES.MERCHANT_PAYMENTS}
          Component={MerchantPaymentsPage}
          accessRole={UserRoles.MERCHANT}
        />

        <Route exact path={ROUTES.MERCHANT_LOGIN} component={MerchantLoginPage} />
        <Route exact path={ROUTES.MERCHANT_SIGNUP} component={MerchantSignupPage} />
        <Route exact path={ROUTES.MERCHANT_SET_PASSWORD} component={MerchantSetPasswordPage} />
        <Route exact path={ROUTES.MERCHANT_RESET_PASSWORD} component={MerchantResetPasswordPage} />
        <Route exact path={ROUTES.MERCHANT_CREATE_PROFILE} component={MerchantCreateProfilePage} />
        <Route
          exact
          path={ROUTES.MERCHANT_RECOVER_PASSWORD}
          component={MerchantRecoverPasswordPage}
        />
        
        <ProtectedRoute
          exact
          path={ROUTES.MERCHANT_OFFERS_LIST}
          Component={MerchantPerksListingPage}
          accessRole={UserRoles.MERCHANT}
        />
        
        <ProtectedRoute
          exact
          path="/offers/create"
          Component={MerchantOfferCreateOrEditPage}
          accessRole={UserRoles.MERCHANT}
        />
        
        <ProtectedRoute
          exact
          path="/offers/edit"
          Component={MerchantOfferCreateOrEditPage}
          accessRole={UserRoles.MERCHANT}
        />

        <ProtectedRoute
          exact
          path={ROUTES.MERCHANT_CUSTOMER_SIGNUP}
          Component={MerchantCustomerSignupPage}
          accessRole={UserRoles.MERCHANT}
        />

        
        <Redirect from={ROUTES.MERCHANT} to={ROUTES.MERCHANT_LOGIN} />

        <Route path="*" component={NotFoundPage} />
      </Switch>
    </ScrollToTop>
  </Router>
);

export default Routes;
